var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCinVerificationBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8035",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 13.0273V3.41797H0.976562V46.6602H49.0234V13.0273H25ZM20.1953 41.8555H5.78125V37.0508H20.1953V41.8555ZM20.1953 32.2461H5.78125V27.4414H20.1953V32.2461ZM20.1953 22.6367H5.78125V17.832H20.1953V22.6367ZM20.1953 13.0273H5.78125V8.22266H20.1953V13.0273ZM44.2188 41.8555H25V17.832H44.2188V41.8555ZM39.4141 22.6367H29.8047V27.4414H39.4141V22.6367ZM39.4141 32.2461H29.8047V37.0508H39.4141V32.2461Z",
    fill: "#1D3A6D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinVerificationBlue);
export default __webpack_public_path__ + "static/media/cin_verification_blue.e5799afcde8dcbfaa10e95a5a1c41cba.svg";
export { ForwardRef as ReactComponent };